<template>
  <div id="app">
    <h1 style="margin-top:10%; margin-bottom:5%; font-size:26px;">내 이름은 어떤 색일까요?</h1>



    <ColorGenerator class="element" msg="Welcome to Your Vue.js App"/>


    <h3 class="element" style="font-size: 13px;
    z-index:2; position:absolute; bottom:60px; left:0; right:0; margin: 0 auto;">ⓒ 김병헌 이준수 만듦</h3>

  </div>
</template>

<script>
import ColorGenerator from './components/ColorGenerator.vue'

export default {
  name: 'app',
  components: {
    ColorGenerator
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Noto+Serif+KR&display=swap');
#app {

  font-family: 'Noto Serif KR', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  margin-top: 60px;
  display: block;
  justify-content: center;
  align-content: center;
}

.element{
  display: block
}
</style>
